import { useNls } from '../../../nls/nlsProvider'
import { Pressable } from '../../Common'
import './MemberSystemPulse.css'

export type MemberSystemPulseProps = {
  workspaceCount: number
  unreadCount: number
  pendingSyncCount: number
  failedSyncCount: number
  onOpenSyncCenter?: () => void
}

export const MemberSystemPulse = ({
  workspaceCount,
  unreadCount,
  pendingSyncCount,
  failedSyncCount,
  onOpenSyncCenter,
}: MemberSystemPulseProps) => {
  const { t } = useNls()

  const tiles = [
    { key: 'workspaces', label: t('NLSMemberSystemPulseWorkspaces'), value: workspaceCount },
    { key: 'unread', label: t('NLSMemberSystemPulseUnread'), value: unreadCount },
    { key: 'queued', label: t('NLSMemberSystemPulseQueued'), value: pendingSyncCount, action: onOpenSyncCenter },
    { key: 'failed', label: t('NLSMemberSystemPulseFailed'), value: failedSyncCount, action: onOpenSyncCenter },
  ]

  return (
    <section className="memberSystemPulse" aria-label={t('NLSMemberSystemPulseTitle')}>
      <p className="memberSystemPulse__eyebrow">{t('NLSMemberSystemPulseTitle')}</p>
      <div className="memberSystemPulse__grid">
        {tiles.map(({ key, label, value, action }) =>
          action ? (
            <Pressable
              key={key}
              data-testid={`member-pulse-${key}`}
              onClick={action}
              className="memberSystemPulse__tile memberSystemPulse__tile--actionable text-left"
              aria-label={`${label}: ${value}`}
            >
              <span>{label}</span>
              <strong>{value}</strong>
            </Pressable>
          ) : (
            <div key={key} data-testid={`member-pulse-${key}`} className="memberSystemPulse__tile">
              <span>{label}</span>
              <strong>{value}</strong>
            </div>
          ),
        )}
      </div>
      <p className="memberSystemPulse__detail">
        {t('NLSMemberSystemPulseDetail', { pending: pendingSyncCount, failed: failedSyncCount })}
      </p>
    </section>
  )
}
